import { createContext, useContext } from 'react';
export const SipCallContext = createContext(null);
export function useSipCall() {
    const ctx = useContext(SipCallContext);
    if (!ctx) {
        throw new Error('useSipCall must be used inside SipCallProvider.');
    }
    return ctx;
}
